import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'react-query';

import { fetchReportLibrary } from '../api/fetchReportLibrary';

export function useReportLibrary(eventId: number | undefined) {
    return useQuery({
        queryKey: queryKeys.reports.library(eventId ?? 0),
        queryFn: () => fetchReportLibrary(eventId!),
        enabled: Boolean(eventId),
    });
}
